var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.pucks !== null && _vm.pucks.length > 0)?_c('v-list',[_vm._l((_vm.pucks),function(puck){return [_c('PuckListItem',{key:puck.uuid,attrs:{"puck":puck}})]})],2):_c('v-list',[_c('v-list-item',[_c('v-list-item-content',[_c('v-list-item-title',[_vm._v(_vm._s(_vm.$t('noPucksYet')))])],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }